/** Shared layout for Users → Groups and Preferences → Approvals member grids. */
export const ADMIN_TABLE_ROW_HEIGHT = 44;
export const ADMIN_TABLE_HEADER_SEARCH_HEIGHT = 32;
export const ADMIN_TABLE_HEADER_SEARCH_WIDTH = 220;
export const ADMIN_TABLE_SEARCH_HIT_SLOP = {
  top: 8,
  bottom: 8,
  left: 4,
  right: 4,
} as const;
export const ADMIN_TABLE_SEARCH_MAX_LENGTH = 255;
/** Loading, empty, offline, and error bodies use multi-line centred copy. */
export const ADMIN_TABLE_MESSAGE_BODY_ROWS = 2;
